// PERFORMANCE: Custom comparison to skip pan/zoom changes for NodeRenderer
// Pan and zoom are handled via refs inside the component, so we don't need
// to re-render when they change. The visual zoom is handled by CSS transforms
// in the parent FlowchartCanvas component.
export default function areNodeRendererPropsEqual(prevProps, nextProps) {
  // Skip pan and zoom - these are handled via refs, not re-renders
  const { pan: prevPan, zoom: prevZoom, viewportSize: prevViewport, ...prevRest } = prevProps;
  const { pan: nextPan, zoom: nextZoom, viewportSize: nextViewport, ...nextRest } = nextProps;

  // Shallow compare all other props
  const prevKeys = Object.keys(prevRest);
  const nextKeys = Object.keys(nextRest);

  if (prevKeys.length !== nextKeys.length) return false;

  for (const key of prevKeys) {
    if (prevRest[key] !== nextRest[key]) return false;
  }

  return true;
}
